import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import moment from "moment";

import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import { IoQrCodeOutline } from "react-icons/io5";

// Vision UI Dashboard React components
import VuiTypography from "components/VuiTypography";
import VuiBox from "components/VuiBox";
import VuiInput from "components/VuiInput";
import VuiProgress from "components/VuiProgress";
import VuiInfoItemStations from "components/VuiInfoItemStations";
import VuiLabel from "components/VuiLabel";
import VuiLoading from "components/VuiLoading";

import api from "services/api";

//
import breakpoints from "assets/theme/base/breakpoints";
import useWindowDimensions from "hooks/useWindowDimensions";

import colors from "assets/theme/base/colors";

import Pagination from "../usePagination";
import SearchItem from "../SearchItem";

const INFO_TABLE_GRID = 0;
const INFO_TABLE_LIST = 1;
const INFO_TABLE_GRID_QRCODE = 2;

const ButtonIconItem = ({ name = "person", fontSizeIcon = "32px", onClick }) => {
  return (
    <IconButton size="small" color="inherit" variant="contained" onClick={onClick}>
      <Icon fontSize={fontSizeIcon}>{name}</Icon>
    </IconButton>
  );
};

const ButtonIconQrCode = ({ name = "person", fontSizeIcon = "20px", onClick }) => {
  return (
    <IconButton color="inherit" variant="contained" onClick={onClick}>
      <IoQrCodeOutline fontSize={fontSizeIcon} />
    </IconButton>
  );
};

function Stations() {
  const { height, width } = useWindowDimensions();
  const [toogleInfo, setToogleInfo] = useState(INFO_TABLE_GRID);
  const [isMobile, setIsMobile] = useState(false);
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [rowsInit, setRowsInit] = useState([]);
  const [pages, setPages] = useState(1);
  const [limit, setLimit] = useState(30);

  const [refreshInterval, setRefreshInterval] = useState(60000);
  const [countOffLines, setCountOfflines] = useState(0);
  const [countOnLines, setCountOnlines] = useState(0);
  const [countAllStations, setCountAllStations] = useState(0);
  const [filterActive, setFilterActive] = useState(false);

  async function loadStations() {
    const res = await api.get(`devices?type=1&page=${pages}&limit=${limit}`);
    const data = res.data;

    console.log(">>> loadStations:data:", data);
    setCountAllStations(res.data[0]?.countAllRegister);
    setRows(data);
    setRowsInit(data);
    setLoading(false);
  }

  useEffect(() => {
    loadStations();
  }, [false]);

  // useEffect(() => {
  //   if (refreshInterval && refreshInterval > 0) {
  //     const interval = setInterval(loadStations, refreshInterval);
  //     return () => clearInterval(interval);
  //   }
  // }, [refreshInterval]);

  useEffect(() => {
    // A function that sets the display state for the DefaultNavbarMobile.
    function displayMobileNavbar() {
      if (window.innerWidth < breakpoints.values.lg) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    }

    /** 
       The event listener that's calling the displayMobileNavbar function when 
       resizing the window.
      */
    window.addEventListener("resize", displayMobileNavbar);

    // Call the displayMobileNavbar function to set the state with the initial value.
    displayMobileNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", displayMobileNavbar);
  }, []);

  return (
    <Card
      sx={{
        height: "100% !important",
      }}
    >
      <VuiBox
        sx={{
          "& th": {
            borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
              `${borderWidth[1]} solid ${grey[700]}`,
          },
          "& .MuiTableRow-root:not(:last-child)": {
            "& td": {
              borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                `${borderWidth[1]} solid ${grey[700]}`,
            },
          },
        }}
      >
        {loading ? (
          <VuiLoading />
        ) : (
          <VuiBox>
            <div
              style={{
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                fontSize: 24,
                marginBottom: 20,
              }}
            >
              <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end" }}>
                <VuiLabel
                  title={`Total de ${countAllStations} Computadores em Monitorando`}
                  sizeTitle={"24px"}
                  colorTitle="warning"
                />
              </div>
              <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end" }}>
                {countOffLines > 0 ? (
                  <VuiLabel
                    title={`${
                      countOffLines > 0 && countOffLines < countAllStations
                        ? ((countOffLines / countAllStations) * 100).toFixed(2)
                        : 100
                    }%`}
                    colorTitle={"warning"}
                    sizeTitle={18}
                    subtitle="&nbsp;Offline"
                    colorSubTitle="error"
                    sizeSubTitle={18}
                  />
                ) : (
                  <>
                    <div style={{ textAlign: "right", color: colors.success.focus }}>100%</div>
                    <div
                      style={{ fontWeight: "bold", textAlign: "right", color: colors.success.main }}
                    >
                      Online
                    </div>
                  </>
                )}
              </div>

              <VuiProgress
                value={(countOffLines / countAllStations) * 100}
                color="error"
                label={false}
              />

              {isMobile ? null : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    color: "white",
                    marginTop: 10,
                  }}
                >
                  {toogleInfo === INFO_TABLE_GRID || toogleInfo === INFO_TABLE_GRID_QRCODE ? (
                    <>
                      <SearchItem
                        onClick={async (text) => {
                          const filterRows = rows.filter((x) =>
                            x["hostname"].toLowerCase().includes(text)
                          );

                          setFilterActive(true);

                          if (filterRows.length === 0) {
                            console.log(
                              `>>> SearchItem:api.get:devices?search=${text}&field=hostname`
                            );
                            const res = await api.get(
                              `devices?type=1&search=${text}&field=hostname`
                            );

                            setRows(res.data.sort((a, b) => a.hostname - b.hostname));
                          } else {
                            setRows(filterRows);
                          }
                        }}
                        onReset={() => {
                          setRows(rowsInit);
                          setFilterActive(false);
                        }}
                      />
                      {!filterActive ? (
                        <Pagination
                          currentPage={pages}
                          totalPages={Math.round(countAllStations / limit)}
                          onChange={async (page) => {
                            if (page > 0 && page <= Math.round(countAllStations / limit)) {
                              // setLoading(true);
                              console.log(
                                `>>> Pagination:api.get:devices?type=1&page=${page}&limit=${limit}`
                              );
                              const res = await api.get(
                                `devices?type=1&page=${page}&limit=${limit}`
                              );
                              console.log(">>> res:", res.data);
                              setCountAllStations(res.data[0]?.countAllRegister);
                              setRows(res.data);
                              // setRowsInit(res.data);
                              setPages(page);
                              // setLoading(false);
                            }
                          }}
                        />
                      ) : (
                        <></>
                      )}
                    </>
                  ) : (
                    <div>
                      <div></div>
                    </div>
                  )}

                  <VuiTypography
                    variant="lg"
                    display="flex"
                    flexDirection="row"
                    justifyContent="flex-end"
                    alignItems="center"
                    color="white"
                    p={"10px"}
                  >
                    <ButtonIconQrCode
                      onClick={async () => {
                        setToogleInfo(INFO_TABLE_GRID_QRCODE);
                      }}
                    />

                    <ButtonIconItem
                      name="grid_view"
                      onClick={() => {
                        setToogleInfo(INFO_TABLE_GRID);
                      }}
                    />

                    <div style={{ width: 5 }} />

                    <ButtonIconItem
                      name="list_view"
                      onClick={() => {
                        setToogleInfo(INFO_TABLE_LIST);
                      }}
                    />
                  </VuiTypography>
                </div>
              )}
            </div>

            {toogleInfo === INFO_TABLE_GRID || toogleInfo === INFO_TABLE_GRID_QRCODE ? (
              <Box sx={{ flexGrow: 2 }}>
                <Grid container spacing={{ xs: 1, md: 1 }} columns={{ xs: 3, sm: 6, md: 18 }}>
                  {rows.map((item, index) => {
                    return (
                      <VuiInfoItemStations
                        item={item}
                        index={index}
                        qrcode={toogleInfo === INFO_TABLE_GRID_QRCODE}
                      />
                    );
                  })}
                </Grid>
              </Box>
            ) : null}
          </VuiBox>
        )}
      </VuiBox>
    </Card>
  );
}

export default Stations;
